import React from 'react';
import {
    shape,
    arrayOf,
    string,
    bool,
    number,
    oneOfType,
    func
} from 'prop-types';

import Icon from '../../icon';

const ActiveFiltersLayout = ({
    activeFilters,
    clearKeywordInputValue,
    resetFilters,
    toggleFilters,
    componentTitleText
}) => {
    const handleRemoveClick = (value, groupCode) => {
        if (groupCode.code === 'Allnex.Keyword') {
            clearKeywordInputValue(groupCode);
        } else {
            toggleFilters(activeFilters, groupCode, value);
        }
    };

    const formatValue = string => {
        const formatedValue = string.replace('&amp;', '&');

        const removeParentLabel = formatedValue.includes('||')
            ? formatedValue.split('||')[1]
            : formatedValue;

        return removeParentLabel;
    };

    return (
        <div className="active-filters-layout">
            <h2>{componentTitleText}</h2>
            <div className="active-filter-tags-wrapper">
                {activeFilters.map(filter =>
                    filter.values.map(value => (
                        <div className="active-filter-tag" key={value}>
                            {formatValue(value)}
                            <button
                                onClick={() => handleRemoveClick(value, filter)}
                                type="button"
                            >
                                <Icon glyph="cross" />
                            </button>
                        </div>
                    ))
                )}
            </div>
            {!!activeFilters.length && (
                <button
                    className="link"
                    onClick={resetFilters}
                    onKeyPress={resetFilters}
                    type="button"
                >
                    Clear filters
                </button>
            )}
        </div>
    );
};

export default ActiveFiltersLayout;

ActiveFiltersLayout.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    activeFilters: arrayOf(
        shape({
            code: string.isRequired,
            label: string.isRequired,
            values: arrayOf(oneOfType([string, bool, number])).isRequired
        })
    ).isRequired,
    componentTitleText: string.isRequired,
    toggleFilters: func.isRequired,
    resetFilters: func.isRequired,
    clearKeywordInputValue: func.isRequired
    /* eslint-enable react/no-typos */
};
